import React from 'react';
import { Box, Grid, TextField, Button, Checkbox, ListItemText } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useCallback, useMemo, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import { useTranslation } from "react-i18next";
import InputAdornment from '@mui/material/InputAdornment';
import axios from "../../../utils/fvAxios";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import "../../../Localization/i18n";
import apiinfo from "../../../utils/base-uri.json";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { log } from 'mathjs';
import { Check } from '@mui/icons-material';
import { CSVLink } from "react-csv";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function NewCompany() {

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [files, setFiles] = useState([]);


    const activeStyle = {
        borderColor: "#2196f3",
    };

    const acceptStyle = {
        borderColor: "#00e676",
    };

    const rejectStyle = {
        borderColor: "#ff1744",
    };
    const onDrop = useCallback((acceptedFiles) => {
        setFiles(
            acceptedFiles?.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            )
        );
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: { 'csv': ['.csv'] },
        maxFiles: 1,
    });

    const mmmt = useMemo(
        () => ({
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );

    const thumbs = files?.map((file) => <div key={file?.name}>{file?.name}</div>);
    useEffect(
        () => () => {
            files?.forEach((file) => URL.revokeObjectURL(file?.name));
        }, []
    );






    // const [FileReset, setFileReset] = useState(false);

    // const activeStyle = {
    //     borderColor: '#2196f3'
    // };

    // const acceptStyle = {
    //     borderColor: '#00e676'
    // };

    // const rejectStyle = {
    //     borderColor: '#ff1744'
    // };

    // const {
    //     acceptedFiles,
    //     fileRejections,
    //     isDragActive,
    //     isDragAccept,
    //     isDragReject,
    //     getRootProps,
    //     getInputProps
    // } = useDropzone({
    //     accept: {
    //         '.CSV': [],
    //     },
    //     maxFiles: 1
    // });

    const style = useMemo(() => ({

        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    // const acceptedFileItems = acceptedFiles.map(file => (
    //     <li key={file.path}>
    //         {file.path} - {file.size} bytes
    //     </li>
    // ));

    // useEffect(() => () => {
    //     acceptedFiles?.forEach(file => URL.revokeObjectURL(file?.name));
    // }, [FileReset]);

    // This code is reject files 
    // const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    //     <li key={file.path}>
    //         {file.path} - {file.size} bytes
    //         <ul>
    //             {errors.map(e => (
    //                 <li key={e.code}>{e.message}</li>
    //             ))}
    //         </ul>
    //     </li>
    // ));



    // Use the useDropzone hook for the second dropzone
    const {
        acceptedFiles: acceptedFiles1,
        fileRejections: fileRejections1,
        isDragActive: isDragActive1,
        isDragAccept: isDragAccept1,
        isDragReject: isDragReject1,
        getRootProps: getRootProps1,
        getInputProps: getInputProps1
    } = useDropzone({
        accept: {
            'image/png': []
        }
    });

    // Map over the accepted and rejected files for the second dropzone
    const acceptedFileItems1 = acceptedFiles1.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));



    const {
        acceptedFiles: acceptedFiles2,
        fileRejections: fileRejections2,
        isDragActive: isDragActive2,
        isDragAccept: isDragAccept2,
        isDragReject: isDragReject2,
        getRootProps: getRootProps2,
        getInputProps: getInputProps2
    } = useDropzone({
        accept: {
            'image/png': []
        }
    });

    // Map over the accepted and rejected files for the second dropzone
    const acceptedFileItems2 = acceptedFiles2.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));


    const data = [{
        "CompanyName": " Test By Name",
        "TaxId": "9090900799",
        "PrincipleOffice": "Test",
        "Address": "Test",
        "City": "Test",
        "Zip": "12321",
        "Country": "test",
        "State": "Test",
        "First Name": "Test",
        "Last Name": "User",
        "Email": "testuser3@claycobulk.com",
        "Password": "Password#123"
    }];

    const headers = [
        { label: "CompanyName", key: "CompanyName" },
        { label: "TaxId", key: "TaxId" },
        { label: "PrincipleOffice", key: "PrincipleOffice" },
        { label: "Address", key: "Address" },
        { label: "City", key: "City" },
        { label: "Zip", key: "Zip" },
        { label: "Country", key: "Country" },
        { label: "State", key: "State" },
        { label: "First Name", key: "First Name" },
        { label: "Last Name", key: "Last Name" },
        { label: "Email", key: "Email" },
        { label: "Password", key: "Password" },
    ]

    const csvLink = {
        filename: 'Sample Bulk Vendor Registration.csv',
        headers: headers,
        data: data
    }

    const data1 = [{
        "TaxId": "34334555"
    }];

    const headers1 = [
        { label: "TaxId", key: "TaxId" }
    ]

    const csvLink1 = {
        filename: 'Sample Bulk Location Vendor Registration.csv',
        headers: headers1,
        data: data1
    }


    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [tax, setTax] = useState('');
    const [PrincipalOfficerName, setPrincipalOfficerName] = useState('');
    const [City, setCity] = useState('');
    const [Zip, setZip] = useState('');
    const [Address, setAddress] = useState('');
    const [Address2, setAddress2] = useState('');
    const [Address3, setAddress3] = useState('');
    const [Telephone, setTelephone] = useState('');
    const [Phone, setPhone] = useState('');
    const [Fax, setFax] = useState('');
    const [url, setUrl] = useState('');
    const [registration, setRegistration] = useState("0");
    const [Organization, setOrganization] = useState("Vendor");
    const [langauageId, setLangauageId] = useState("");
    const [langauages, setLangauages] = useState([]);
    const [TrainingRequired, setTrainingRequired] = useState(false);
    const [AccptVendors, setAccptVendors] = useState(false);
    const [RepresentativeName, setRepresentativeName] = useState('');
    const [RepresentativeEmail, setRepresentativeEmail] = useState('');
    const [InfusionSoftContactID, setInfusionSoftContactID] = useState('');
    const [copy, SetCopy] = useState('2');
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [counrtyid, setCounrtyid] = useState("");
    const [stateid, setStateid] = useState("");
    const [RegionsList, setRegionsList] = useState([]);
    const [RegionsListIds, setRegionsListIds] = useState([]);

    const [BulkActions, setBulkActions] = useState("0");
    const [ClientList, setClientList] = useState([]);
    const [ClientId, setClientId] = useState("");
    const [ClientTemplateList, setClientTemplateList] = useState([]);
    const [ClientTemplateId, setClientTemplateId] = useState("");


    const [SelectSubClientIds, setSelectSubClientIds] = useState([]);
    const [SelectSubClients, setSelectSubClients] = useState([]);

    const [state, setSate] = useState(false);
    const [telephoneError, setTelephoneError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [FaxError, setFaxError] = useState(null);

    useEffect(() => {
        GetClients();
    }, []);

    const GetClients = async () => {
        const re = await axios.get(apiinfo.addressInfo.getCountries);
        setCountries(re?.data?.data);
        getState(re?.data?.data[0]?.value)

        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=true");
        setClientList(res?.data?.data);

        const resp = await axios.get("Common/GetRegions");
        setRegionsList(resp?.data?.data);
        //setRegionsListIds("0");


        const response = await axios.get("Client/GetAllSubClients");
        setSelectSubClients(response?.data?.data);
    }

    const ChangeClients = async (e) => {
        setClientId(e);
        const res = await axios.get("Client/GetClientTemplates?clientId=" + e);
        setClientTemplateList(res?.data?.data);
    };

    const getState = async (e) => {
        setCounrtyid(e);
        const res = await axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + e);
        setStates(res?.data?.data);
        setStateid(res?.data?.data[0]?.value);

        const resp = await axios.get("Companies/GetCountryLanguages?countryName=" + e);
        setLangauages(resp?.data?.data);
        setLangauageId(resp?.data?.data[0]?.key);
    }
    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        const numericInput = inputValue.replace(/[^0-9]/g, '');
        if (numericInput.length <= 10) {
            if (numericInput === '') {
                // Field is empty, no error
                setTelephone('');
                setTelephoneError(true);
            } else if (/^\d{10}$/.test(numericInput)) {
                const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                setTelephone(formattedInput);
                setTelephoneError(false);
            } else {
                setTelephone(numericInput);
                setTelephoneError(true);
            }
        } else {
            // Limit to 10 digits, no further input allowed
            setTelephone(numericInput.slice(0, 9));
            setTelephoneError(true);
        }
    };

    const ChangeFax = (event) => {
        const inputValue = event.target.value;
        const numericInput = inputValue.replace(/[^0-9]/g, '');
        if (numericInput.length <= 10) {
            if (numericInput === '') {
                // Field is empty, no error
                setFax('');
                setFaxError(false);
            } else if (/^\d{10}$/.test(numericInput)) {
                const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                setFax(formattedInput);
                setFaxError(false);
            } else {
                setFax(numericInput);
                setFaxError(true);
            }
        } else {
            // Limit to 10 digits, no further input allowed
            setFax(numericInput.slice(0, 9));
            setFaxError(true);
        }
    };

    const Clear = () => {
        setBulkActions("0");
        setClientTemplateId("");
        setClientId("");
        // setFileReset(!FileReset);
        setFiles([]);
    }

    const Reset = () => {
        setName('');
        setTax('');
        setPrincipalOfficerName('');
        setCity('');
        setZip('');
        setAddress('');
        setAddress2('');
        setAddress3('');
        setTelephone('');
        setPhone('');
        setFax('');
        setUrl('');
        setRegistration("0");
        setOrganization("Vendor");
        setLangauageId("");
        setTrainingRequired(false);
        setAccptVendors(false);
        setRepresentativeName('');
        setRepresentativeEmail('');
        setInfusionSoftContactID('');
        SetCopy('2');
        setStateid(states[0]?.value);
        getState(countries[0]?.value);
        //setRegionsListIds(RegionsList[0]?.key);
        setSelectSubClientIds([]);
    }

    // formData.append('isSuccess', null);//Done
    // formData.append('isCompanyExist', null);//Done
    // formData.append('ConfirmDelete', null);//Done
    // formData.append('TrainingCertificate', null);//Done
    
    const handleSubmit = (val) => {

        if (val == 1) {
            setSate(true);
            const formData = new FormData();
            formData.append('clientId', ClientId);
            formData.append('templateId', ClientTemplateId);
            formData.append('file', files[0]);
            axios.post('Companies/BulkVendorInsertion',
                formData, { headers: { "Content-Type": "application/json" } }
            ).then((res) => {
                if (res?.data?.responseCode == "100") {
                    toastNotify(res?.data?.responseMessage, true);
                    Clear();
                    setSate(false);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setSate(false);
            })
        } else if (val == 2) {
            setSate(true);
            const formData = new FormData();
            formData.append('clientId', ClientId);
            formData.append('templateId', ClientTemplateId);
            formData.append('file', files[0]);
            axios.post('Companies/BulkVendorLocationInsertion',
                formData, { headers: { "Content-Type": "application/json" } }
            ).then((res) => {
                if (res?.data?.responseCode == "100") {
                    toastNotify(res?.data?.responseMessage, true);
                    Clear();
                    setSate(false);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setSate(false);
            })
        } else {
            // const Regions = RegionsListIds?.toString();
            if (!name || !Address || !Zip || !counrtyid || !Telephone || !stateid || !City) {
                toastNotify("Please fill all the mandatory fields", false);
            } else {
                setSate(true);
                const formData = new FormData();
                formData.append('OrganizationID', -5);//done
                formData.append('CountryType', registration);//Done
                formData.append('Name', name);//Done
                formData.append('PrincipalCompanyOfficerName', Organization == "Vendor" ? PrincipalOfficerName : "");//Done
                formData.append('TaxID', Organization == "Vendor" ? tax : "");//Done
                formData.append('Address1', Address);//Done
                formData.append('Address2', Address2);//Done
                formData.append('Address3', Address3);//Done
                formData.append('City', City);//Done
                formData.append('State', stateid);//Done
                formData.append('FinancialMonth', "");
                formData.append('FinancialDate', "");
                formData.append('Zip', Zip);//Done
                formData.append('Country', counrtyid);//Done
                formData.append('PhoneNumber', Telephone);//Done
                formData.append('FaxNumber', Fax);//Done
                formData.append('WebsiteURL', url);//Done
                formData.append('FederalIDNumber', "");
                if (Organization != "Vendor") {
                    formData.append('AcceptVendorsViaInvite', AccptVendors);//Done
                }
                if (Organization != "Vendor") {
                    formData.append('TrainingRequired', TrainingRequired);//Done
                    formData.append('MoodleTrainingRequired', true);//Done
                }
                formData.append('TrainingFeeCap', "");

                formData.append('OrganizationType', Organization);//Done

                formData.append('ClientSecrte', "");
                formData.append('Prequalification', "");
                formData.append('Documents', "");
                formData.append('QuestionarieTypeId', "");
                formData.append('IntroContentStr', "");
                formData.append('QuestionarieTypeIdForPrequalRequirements', "");
                formData.append('Logo', "");
                formData.append('Photo', "");
                formData.append('OrgRepresentativeName', RepresentativeName);//Done 
                formData.append('OrgRepresentativeEmail', RepresentativeEmail);//DOne
                formData.append('OrgInfusionSoftContactId', InfusionSoftContactID);//Done
                formData.append('SingleClientCode', "");
                formData.append('CopyAnswers', Organization == "Vendor" ? copy : ""); //Done
                formData.append('ExtNumber', Phone);//Done
                if (Organization == "Super Client") {
                    formData.append('Clients', SelectSubClients);//Done
                }
                formData.append('Language', Organization == "Vendor" ? langauageId : "");//Done
                formData.append('GeographicArea', Organization == "Vendor" ? RegionsListIds?.toString() : "");
                formData.append('DisabledClients', "");
                formData.append('VendorArchivedDetails', "");
                formData.append('ContractorEvaluationExpirationPeriod', "");
                formData.append('EmployeeSelfRegistrationURL', "");
                formData.append('OrgnaizationPhoto', acceptedFiles2[0]);//Done
                formData.append('OrgnaizationLogo', acceptedFiles1[0]);//Done
                formData.append('LogoBlob', "");
                formData.append('PhotoBlob', "");

                axios.post('Companies/AddNewCompany',
                    formData,
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                ).then((res) => {
                    if (res?.data?.responseCode == "100") {
                        toastNotify(res?.data?.responseMessage, true);
                        Reset();
                        setSate(false);
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                        setSate(false);
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setSate(false);
                })
            }
        }
    };


    const ChangeState = (e) => {
        setStateid(e);
    }

    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
                width: 200,
            },
        },
    };



    return (

        <>
            <ToastContainer />
            <Grid container spacing={2}>
                <Grid item xs={2} md={1}>
                </Grid>

                <Grid item xs={12} md={10}>
                    <Box
                        border={1}
                        borderLeft={1}
                        borderRight={1}
                        borderColor="#e4e7ec"
                        className="mt-2"
                        sx={{ background: "#fff", padding: "" }}
                    >
                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px" }}
                        >
                            <Grid item xs={12} sm={6} md={6} >
                                <p
                                    className="mt-2"
                                    style={{ fontSize: "500px", color: "#3E4A62", fontSize: "20px", fontWeight: "500", marginBottom: 0 }}
                                >
                                    {t('ClientEditBusinessInfo.label1')}
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}></Grid>
                        </Grid>
                        <hr />

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>
                                <p
                                    style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                >

                                    Organization Type <span style={{ color: "red" }}> *</span>
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>
                                <FormControl>
                                    <RadioGroup
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={Organization}
                                        onChange={(event) => {
                                            setOrganization(event.target.value)
                                            setBulkActions("0")
                                        }}
                                    >
                                        <FormControlLabel
                                            value="Vendor"
                                            control={<Radio />}
                                            label="Vendor"
                                        />
                                        <FormControlLabel
                                            value="Client"
                                            control={<Radio />}
                                            label="Client"
                                        />
                                        <FormControlLabel
                                            value="Super Client"
                                            control={<Radio />}
                                            label="Super Client"
                                        />
                                    </RadioGroup>

                                </FormControl>
                            </Grid>
                        </Grid>
                        <hr />

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px", display: Organization == "Vendor" ? "" : "none" }}

                        >
                            <Grid item xs={12} sm={5} md={5}>
                                <p
                                    style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                >
                                    Bulk Actions
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>
                                <FormControl>
                                    <RadioGroup
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={BulkActions}
                                        onChange={(event) => {
                                            setBulkActions(event.target.value)
                                            setFiles([]);
                                            setClientId("");
                                            setClientTemplateId("");
                                        }}
                                    >
                                        <FormControlLabel
                                            value="0"
                                            control={<Radio />}
                                            label="Off"
                                        />
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio />}
                                            label="Vendor Bulk Registration"
                                        />
                                        <FormControlLabel
                                            value="2"
                                            control={<Radio />}
                                            label="Add Locations For  Vendors"
                                        />
                                    </RadioGroup>

                                </FormControl>
                            </Grid>
                        </Grid>
                        <hr style={{
                            display: Organization == "Vendor" ? "" : "none"
                        }} />

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px", display: Organization == "Vendor" && BulkActions != "0" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>
                                <p
                                    style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                >
                                    Clients
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>
                                <FormControl fullWidth>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={ClientId || ""}
                                        onChange={(e) => ChangeClients(e.target.value)}
                                        size="small"
                                        MenuProps={MenuProps}
                                        sx={{
                                            width: "299px",
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                    >
                                        {ClientList?.map((r, i) =>
                                            <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                        <hr style={{ display: Organization == "Vendor" && BulkActions == "1" ? "" : "none" }} />

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px", display: Organization == "Vendor" && BulkActions == "1" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>
                                <p
                                    style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                >
                                    Select Template
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>
                                <FormControl fullWidth>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={ClientTemplateId || ""}
                                        label="Age"
                                        onChange={(e) => setClientTemplateId(e?.target?.value)}
                                        size="small"
                                        MenuProps={MenuProps}
                                        sx={{
                                            width: "299px",
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                    >
                                        {ClientTemplateList?.map((r, i) =>
                                            <MenuItem key={i} value={r?.key} > {r?.value}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                                {/* <br /><br />
                                <CSVLink style={{ width: "150px", textDecoration: "none", color: "#101828", borderStyle: "solid", borderColor: "#E4E7EC", borderRadius: "2px" }}
                                    {...csvLink}> DOWNLOAD CSV TEMPLATE</CSVLink> */}

                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px", display: Organization == "Vendor" && BulkActions == "1" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>

                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>

                                <CSVLink style={{ width: "150px", textDecoration: "none", color: "#101828", borderStyle: "solid", borderColor: "#E4E7EC", borderRadius: "2px" }}
                                    {...csvLink}> Sample Bulk Vendor Registration
                                </CSVLink>

                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "10px", display: Organization == "Vendor" && BulkActions == "2" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>

                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>

                                <CSVLink style={{ width: "150px", textDecoration: "none", color: "#101828", borderStyle: "solid", borderColor: "#E4E7EC", borderRadius: "2px" }}
                                    {...csvLink1}> Sample Bulk Location Vendor Registration
                                </CSVLink>

                            </Grid>
                        </Grid>
                        <hr style={{ display: Organization == "Vendor" && BulkActions != "0" ? "" : "none" }} />

                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "15px", display: Organization == "Vendor" && BulkActions != "0" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={5} md={5}>
                                <p
                                    style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                >
                                    Upload File
                                </p>
                            </Grid>
                            <Grid item xs={2} sm={4} md={3}>
                                <div
                                    className="drop"
                                    {...getRootProps({ mmmt })}
                                    style={{ width: "300px", padding: "15px" }}
                                >
                                    <input {...getInputProps()} />

                                    <span className="text-muted mt-2 fs">
                                        <b>
                                            <span className="mx-1 cl">
                                                {t("DragandDrop.firstLabel1")}{" "}
                                                <span className=" text-muted Fs">
                                                    or drag and drop
                                                </span>

                                            </span>
                                        </b>
                                        <br />
                                        only .csv file
                                    </span>
                                    <br />

                                    <span className=" text-muted Fs"> {thumbs}</span>
                                </div>

                                {/* <div {...getRootProps({ style })} className="drop" style={{ width: "300px" }}>
                                    <img className='mt-2' src={Logo} alt="" />
                                    <br />
                                    <input {...getInputProps()} accept=".csv" />
                                    <span className='text-muted mt-2 fs'>
                                        <b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span></b>
                                    </span>
                                    <br />
                                    <span className=' text-muted Fs'>
                                        {t('Only .csv')}
                                    </span>
                                    <span className=' text-muted Fs'> {acceptedFileItems}</span>
                                </div> */}

                            </Grid>
                        </Grid>

                        <hr style={{ display: BulkActions == "1" ? "" : "none" }} />
                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "15px", display: BulkActions == "1" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={12} md={12}>
                                <div style={{ float: "right", marginBottom: "10px" }}>
                                    <Button
                                        disabled={state == true}
                                        variant="contained"
                                        color="primary"
                                        sx={{ padding: "15px", textTransform: "capitalize" }}
                                        onClick={() => handleSubmit(1)}
                                    >
                                        Save
                                    </Button>
                                    {/* <Button variant="contained" sx={{ padding: "10px" }} onClick={() => handleSubmit(1)}>Save </Button> */}
                                </div>
                            </Grid>

                        </Grid>

                        <hr style={{ display: BulkActions == "2" ? "" : "none" }} />
                        <Grid
                            container
                            spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            sx={{ padding: "15px", display: BulkActions == "2" ? "" : "none" }}
                        >
                            <Grid item xs={12} sm={12} md={12}>
                                <div style={{ float: "right", marginBottom: "10px" }}>
                                    <Button
                                        disabled={state == true}
                                        variant="contained"
                                        color="primary"
                                        sx={{ padding: "15px", textTransform: "capitalize" }}
                                        onClick={() => handleSubmit(2)}
                                    >
                                        Save
                                    </Button>
                                    {/* <Button variant="contained" sx={{ padding: "10px" }} onClick={() => handleSubmit(2)}>Submit </Button> */}
                                </div>
                            </Grid>

                        </Grid>

                        {/* <hr style={{ display: Organization == "0" && BulkActions != "0" ? "" : "none" }} /> */}
                        {BulkActions == "0" ? <>

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "10px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >

                                        Select type of registration <span style={{ color: "red" }}> *</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={registration}
                                            onChange={(event) => setRegistration(event.target.value)}
                                        >
                                            <FormControlLabel
                                                value="0"
                                                control={<Radio />}
                                                label="	U.S."
                                            />
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio />}
                                                label="International"
                                            />
                                        </RadioGroup>

                                    </FormControl>
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px", display: Organization == "Super Client" ? "" : "none" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Select Sub Client(s)
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    < FormControl >
                                        <Select
                                            labelId="docs-label"
                                            id="docs-select"
                                            multiple
                                            size='small'
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                width: "299px",
                                            }}
                                            name="Site Safety Representive"
                                            value={SelectSubClientIds || []}
                                            MenuProps={MenuProps}
                                            renderValue={(selected) =>
                                                selected
                                                    .map((value) => SelectSubClients?.find((doc) => doc?.key === value)?.value)
                                                    .filter((text) => text !== undefined)
                                                    .join(", ")
                                            }
                                            onChange={(e) => setSelectSubClientIds(e.target.value)}
                                        >
                                            {!SelectSubClients
                                                ?
                                                <MenuItem >
                                                    <ListItemText primary={"No Sub Clients"} />
                                                </MenuItem>
                                                :
                                                SelectSubClients?.map((r, i) => (
                                                    <MenuItem key={i} value={r?.key}>
                                                        <Checkbox checked={SelectSubClientIds?.indexOf(r?.key) > -1} />
                                                        <ListItemText primary={r?.value} />

                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <hr style={{ display: Organization == "Super Client" ? "" : "none" }} />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label4')} <span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        size="small"
                                        id="outlined-name"
                                        fullWidth

                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            {Organization == "Client" || Organization == "Super Client" ? "" :
                                <>
                                    <Grid
                                        container
                                        spacing={{ xs: 2, md: 3 }}
                                        columns={{ xs: 4, sm: 8, md: 12 }}
                                        sx={{ padding: "15px" }}
                                    >
                                        <Grid item xs={12} sm={5} md={5}>
                                            <p
                                                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                            >
                                                {t('ClientEditBusinessInfo.label5')} <span style={{ color: "red" }}>*</span>
                                            </p>
                                        </Grid>
                                        <Grid item xs={2} sm={4} md={4}>
                                            <TextField
                                                sx={{
                                                    "& legend": { display: "none" },
                                                    "& fieldset": { top: 0 },
                                                    width: "299px"
                                                }}
                                                value={tax}
                                                onChange={(event) => setTax(event.target.value)}
                                                size="small"
                                                id="outlined-name"
                                                fullWidth

                                            />
                                        </Grid>
                                    </Grid>
                                    <hr />

                                    <Grid
                                        container
                                        spacing={{ xs: 2, md: 3 }}
                                        columns={{ xs: 4, sm: 8, md: 12 }}
                                        sx={{ padding: "15px" }}
                                    >
                                        <Grid item xs={12} sm={5} md={5}>
                                            <p
                                                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                            >
                                                {t('ClientEditBusinessInfo.label6')} <span style={{ color: "red" }}>*</span>
                                            </p>
                                        </Grid>
                                        <Grid item xs={2} sm={4} md={4}>
                                            <TextField
                                                sx={{
                                                    "& legend": { display: "none" },
                                                    "& fieldset": { top: 0 },
                                                    width: "299px"
                                                }}
                                                value={PrincipalOfficerName}
                                                onChange={(event) => setPrincipalOfficerName(event.target.value)}
                                                size="small"
                                                id="outlined-name"
                                                fullWidth

                                            />
                                        </Grid>
                                    </Grid>
                                    <hr />
                                </>}

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label7')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "299px"
                                        }}
                                        select
                                        required
                                        size='small'
                                        placeholder={t('Mycompany.country')}
                                        name="country"
                                        id="country"
                                        value={counrtyid || ""}
                                        onChange={(e) => getState(e.target.value)}
                                        MenuProps={MenuProps}
                                    >
                                        {countries?.map((item, index) => (
                                            <MenuItem key={index} value={item.value}>
                                                {item.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label8')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "299px"
                                        }}
                                        select
                                        type="state"
                                        id='state'
                                        size='small'
                                        required
                                        MenuProps={MenuProps}
                                        name="state"
                                        value={stateid || ""}
                                        onChange={(e) => ChangeState(e.target.value)}
                                        placeholder={t('Mycompany.state')}
                                    >
                                        {states?.map((item, index) => (
                                            <MenuItem key={index} value={item.value}>
                                                {item.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label9')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={City}
                                        onChange={(event) => setCity(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px", display: Organization == "Vendor" ? "" : "none" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Language <span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <FormControl fullWidth>
                                        <Select
                                            value={langauageId}
                                            onChange={(event) => setLangauageId(event.target.value)}
                                            required
                                            variant="outlined"
                                            size="small"
                                            MenuProps={MenuProps}
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                width: "299px"
                                            }}
                                        >
                                            {langauages?.map((item, index) => (
                                                <MenuItem key={index} value={item?.key}>
                                                    {item?.value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                            </Grid>
                            <hr style={{ display: Organization == "Vendor" ? "" : "none" }} />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label10')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Zip}
                                        onChange={(event) => setZip(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label11')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Address}
                                        onChange={(event) => setAddress(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label12')}
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Address2}
                                        onChange={(event) => setAddress2(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label13')}
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Address3}
                                        onChange={(event) => setAddress3(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label14')}<span style={{ color: "red" }}>*</span>
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: '299px',
                                        }}
                                        value={Telephone}
                                        onInput={handleInputChange}
                                        size="small"
                                        id="outlined-name"
                                        variant="outlined"
                                        error={telephoneError}
                                        helperText={telephoneError ? 'Invalid phone number format. Use (xxx) xxx-xxxx' : ''}
                                    />
                                    {/* <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Telephone}
                                        onChange={(event) => setTelephone(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    /> */}
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label15')}
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    {/* <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Phone}
                                        onChange={(event) => setPhone(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    /> */}
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Phone}
                                        // onChange={(event) => setPhone(event.target.value)}
                                        onChange={(event) => {
                                            const inputValue = event.target.value;
                                            const numericInput = inputValue.replace(/[^0-9]/g, '');

                                            if (numericInput.length <= 10) {
                                                if (numericInput === '') {
                                                    // Field is empty, no error
                                                    setPhone('');
                                                    setPhoneError(false);
                                                } else if (/^\d{10}$/.test(numericInput)) {
                                                    const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                                                    setPhone(formattedInput);
                                                    setPhoneError(false);
                                                } else {
                                                    setPhone(numericInput);
                                                    setPhoneError(true);
                                                }
                                            } else {
                                                // Limit to 10 digits, no further input allowed
                                                // setPhone(numericInput.slice(0, 10));
                                                setPhone(numericInput);
                                                setPhoneError(true);
                                            }
                                        }}
                                        error={phoneError}
                                        helperText={phoneError ? 'Invalid phone number format. Use (xxx) xxx-xxxx' : ''}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label16')}
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: '299px',
                                        }}
                                        value={Fax}
                                        onInput={ChangeFax}
                                        size="small"
                                        id="outlined-name"
                                        variant="outlined"
                                        error={FaxError}
                                        helperText={FaxError ? 'Invalid fax number. Use (xxx) xxx-xxxx' : ''}
                                    />
                                    {/* <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={Fax}
                                        onChange={(event) => setFax(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    /> */}
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        {t('ClientEditBusinessInfo.label17')}
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start" ><Box  >http:// </Box></InputAdornment>,
                                        }}

                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={url}
                                        onChange={(event) => setUrl(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />

                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px", display: Organization != "Vendor" ? "" : "none" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Options
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <FormControl sx={{ marginLeft: "10px" }}>
                                        <FormControlLabel value={AccptVendors} control={<Checkbox onChange={(e) => setAccptVendors(e?.target?.checked)} />} label="Accept Vendors via invite" />
                                        <FormControlLabel value={TrainingRequired} control={<Checkbox onChange={(e) => setTrainingRequired(e?.target?.checked)} />} label="Training Required" />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <hr style={{ display: Organization != "Vendor" ? "" : "none" }} />

                            {Organization == "Client" || Organization == "Super Client" ? "" : <>
                                <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                    sx={{ padding: "15px" }}
                                >
                                    <Grid item xs={12} sm={5} md={5}>
                                        <p
                                            style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                        >
                                            Vendor Operating Region <span style={{ color: "red" }}> *</span>
                                        </p>
                                    </Grid>
                                    <Grid item xs={2} sm={4} md={4}>
                                        <FormControl>

                                            <Select
                                                labelId="docs-label"
                                                id="docs-select"
                                                multiple
                                                size='small'
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "299px",
                                                }}
                                                name="Site Safety Representive"
                                                value={RegionsListIds || []}
                                                MenuProps={MenuProps}
                                                renderValue={(selected) =>
                                                    selected
                                                        .map((value) => RegionsList?.find((doc) => doc?.key === value)?.value)
                                                        .filter((text) => text !== undefined)
                                                        .join(", ")
                                                }
                                                onChange={(e) => setRegionsListIds(e.target.value)}
                                            >
                                                {RegionsList?.map((r, i) => (
                                                    <MenuItem key={i} value={r?.key}>
                                                        <Checkbox checked={RegionsListIds?.indexOf(r?.key) > -1} />
                                                        <ListItemText primary={r?.value} />

                                                    </MenuItem>
                                                ))}
                                            </Select>

                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <hr />

                                <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                    sx={{ padding: "15px" }}
                                >
                                    <Grid item xs={12} sm={5} md={5}>
                                        <p
                                            style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                        >
                                            Copy Answers from Previous Prequalification <span style={{ color: "red" }}> *</span>
                                        </p>
                                    </Grid>
                                    <Grid item xs={2} sm={4} md={4}>

                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                name="controlled-radio-buttons-group"
                                                value={copy}
                                                onChange={(event) => SetCopy(event.target.value)}

                                            >
                                                <FormControlLabel
                                                    value={2}
                                                    control={<Radio />}
                                                    label="Copy Answers"
                                                />
                                                <FormControlLabel
                                                    value={0}
                                                    control={<Radio />}
                                                    label="Do Not Copy Answers"
                                                />
                                            </RadioGroup>

                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <hr />
                            </>}

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Representative Name
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={RepresentativeName}
                                        onChange={(event) => setRepresentativeName(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Representative Email
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={RepresentativeEmail}
                                        onChange={(event) => setRepresentativeEmail(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        InfusionSoft ContactID
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={4}>
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        value={InfusionSoftContactID}
                                        onChange={(event) => setInfusionSoftContactID(event.target.value)}
                                        size="small"
                                        id="outlined-name"

                                    />
                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Select Logo
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={3}>

                                    <div {...getRootProps1({ style })} className="drop" style={{ width: "300px" }}>
                                        <img className='mt-2' src={Logo} alt="" />
                                        <br />
                                        <input {...getInputProps1()} />

                                        <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                                            { }</b></span>
                                        <br />
                                        <span className=' text-muted Fs'>
                                            {t('Only Png Allowed')}</span>
                                        <span className=' text-muted Fs'> {acceptedFileItems1}</span>
                                    </div>

                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={5} md={5}>
                                    <p
                                        style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
                                    >
                                        Select Photo
                                    </p>
                                </Grid>
                                <Grid item xs={2} sm={4} md={3}>

                                    <div {...getRootProps2({ style })} className="drop" style={{ width: "300px" }}>
                                        <img className='mt-2' src={Logo} alt="" />
                                        <br />
                                        <input {...getInputProps2()} />
                                        <span className='text-muted mt-2 fs'>
                                            <b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span></b>
                                        </span>
                                        <br />
                                        <span className=' text-muted Fs'>
                                            {t('Only Png Allowed')}
                                        </span>
                                        <span className=' text-muted Fs'> {acceptedFileItems2}</span>
                                    </div>

                                </Grid>
                            </Grid>
                            <hr />

                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                sx={{ padding: "15px" }}
                            >
                                <Grid item xs={12} sm={12} md={12}>
                                    <div style={{ float: "right", marginBottom: "10px" }}>
                                        {HasPermissions(INFO?.AddNewCompany?.actionName, PER?.ScreenPermissions?.Insert) &&
                                            <Button variant="contained" sx={{ padding: "10px" }} onClick={() => handleSubmit(3)} disabled={state == true || phoneError || telephoneError || FaxError}>{t('ClientEditBusinessInfo.label18')}</Button>
                                        }
                                    </div>
                                </Grid>

                            </Grid>
                        </> : ""}
                    </Box>
                </Grid >
                <Grid item xs={2} md={1}>

                </Grid>
            </Grid >




        </>
    )
}
